/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isLoaded: false,
  loadingCounter: 0,
};

const slice = createSlice({
  name: "loadingStatus",
  initialState,
  reducers: {
    setLoadingCounter: {
      reducer: (state, { payload }) => {
        if (state.loadingCounter === 0 && payload < 0) return;
        state.loadingCounter += payload;
        if (state.loadingCounter > 0) {
          state.isLoading = true;
          state.isLoaded = false;
        }
        if (state.loadingCounter === 0) {
          state.isLoading = false;
          state.isLoaded = true;
        }
      },
    },
  },
});

const { actions, reducer } = slice;
const { setLoadingCounter } = actions;
export { actions, setLoadingCounter };
export default reducer;
